import React from "react";
import Container from "@mui/material/Container";
import Typography from "@mui/material/Typography";
import NavBar from "./NavBar";

const SpecialsPage = () => (
  <>
    <NavBar />
    <Container sx={{ py: 8 }}>
      <Typography
        variant="h3"
        align="center"
        sx={{ mb: 4, color: "#1976d2", fontWeight: 800 }}
      >
        Specials
      </Typography>
      <Typography align="center">
        Check back soon for our latest offers!
      </Typography>
    </Container>
  </>
);

export default SpecialsPage;